// extracted by mini-css-extract-plugin
export default {"ingredientField":"RecipeIngredientField_ingredientField__ohvw2"};